import moment from 'moment';
import { store } from '../store';

const { db } = require('../firebaseConfig');

const NotificacionesDB = db.collection('notificaciones');

export default {
  state: {
    doctorNotificaciones: [],
  },
  getters: {
    getDoctorNotificaciones: state => state.doctorNotificaciones,
  },
  mutations: {
    clearDoctorNotificaciones(state) {
      state.doctorNotificaciones = [];
    },
    agregarDoctorNotificacion(state, valor) {
      if (!valor.visto_doctor) {
        state.doctorNotificaciones.push(valor);
      }
    },
    modifiedDoctorNotificacion(state, valor) {
      if (valor.visto_doctor) {
        state.doctorNotificaciones = state.doctorNotificaciones.filter(notificacion => notificacion.id !== valor.id && notificacion);
      }
      if (!valor.visto_doctor) {
        state.doctorNotificaciones = state.doctorNotificaciones.map((notificacion) => {
          if (notificacion.id === valor.id) {
            notificacion = valor;
          }
          return notificacion;
        });
      }
    },
  },
  actions: {
    doctorNotificaciones({ commit }) {
      commit('clearDoctorNotificaciones');

      const hoyComenzando = Number(moment().startOf('day').format('x'));
      const hoyFinalizando = Number(moment().endOf('day').format('x'));

      NotificacionesDB
        .where('usuario', '==', store.state.provider_email)
        .where('creado_el', '>=', hoyComenzando)
        .where('creado_el', '<=', hoyFinalizando)
        .onSnapshot((notificaciones) => {
          notificaciones.docChanges().forEach((change) => {
            if (change.type === 'added') {
              commit('agregarDoctorNotificacion', {
                ...change.doc.data(),
                id: change.doc.id,
              });
            }
            if (change.type === 'modified') {
              commit('modifiedDoctorNotificacion', {
                ...change.doc.data(),
                id: change.doc.id,
              });
            }
          });
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/js/modules/doctorNotificaciones.js